// base
export const ENTRY = 'entry';

// slice name
export const ENTRY_SLICE_NAME = `${ENTRY}Slice`;

// actionName
const GET_ENTRY_DAILY_STATISTICS = `${ENTRY}/GET_ENTRY_DAILY_STATISTICS`;
const GET_ENTRY_WEEKLY_STATISTICS = `${ENTRY}/GET_ENTRY_WEEKLY_STATISTICS`;
const GET_ENTRY_HISTORY_USER = `${ENTRY}/GET_ENTRY_HISTORY_USER`;
const GET_ENTRY_STATISTICS = `${ENTRY}/getEntryStatistics`;
const GET_ENTRY_STATISTICS_WEEKLY = `${ENTRY}/getEntryStatisticsWeekly`;
const GET_ENTRY_LIST = `${ENTRY}/getEntryList`;

// action type
export const actions = {
  GET_ENTRY_DAILY_STATISTICS,
  GET_ENTRY_WEEKLY_STATISTICS,
  GET_ENTRY_HISTORY_USER,
  GET_ENTRY_STATISTICS,
  GET_ENTRY_STATISTICS_WEEKLY,
  GET_ENTRY_LIST
};
